import styled from "@emotion/styled";

export const ErrorMsg = styled.span`
    color: #d32f2f;
`;

export const InfoMsg = styled.span``;
